const namespace = "Jobrad-Rechner";

export type FeedbackSchema = {
  liked: boolean | undefined;
};

export function getKey(key: string) {
  return namespace + "." + key;
}

export async function persistValue<T>(key: string, value: T) {
  localStorage.setItem(getKey(key), JSON.stringify(value));
}

export async function selectValue<T>(key: string): Promise<T | null> {
  const data = localStorage.getItem(getKey(key));
  if (!data) {
    return null;
  }
  return JSON.parse(data);
}

export const STORAGE_FEEDBACK_KEY = "feedbackProvided";

export const getFeedback = async (): Promise<FeedbackSchema | null> => {
  return await selectValue<FeedbackSchema>(STORAGE_FEEDBACK_KEY);
};
